document.addEventListener('DOMContentLoaded', () => {
  const stickyAtc = document.querySelector('[data-sticky-atc]');
  if (!stickyAtc) return;

  const targetId = stickyAtc.dataset.target;
  const mainProduct = document.getElementById(targetId);
  const originalButton = mainProduct?.querySelector('product-form button[type="submit"]');
  const stickyButton = stickyAtc.querySelector('button');
  const stickySpinners = Array.from(
    stickyButton?.querySelectorAll('.loading__spinner') ?? []
  );

  const toggleVisibility = () => {
    if (!mainProduct || !originalButton) return;
    const rect = mainProduct.getBoundingClientRect();
    const productPassedViewport = rect.bottom <= 0;
    stickyAtc.classList.toggle('sticky-atc--visible', productPassedViewport);
  };

  const syncState = () => {
    if (!originalButton) return;
    const isDisabled =
      originalButton.hasAttribute('disabled') || originalButton.getAttribute('aria-disabled') === 'true';
    if (isDisabled) {
      stickyButton.setAttribute('disabled', 'disabled');
      stickyButton.setAttribute('aria-disabled', 'true');
    } else {
      stickyButton.removeAttribute('disabled');
      stickyButton.removeAttribute('aria-disabled');
    }
    const isLoading = originalButton.classList.contains('loading');
    stickyButton.classList.toggle('loading', isLoading);
    stickySpinners.forEach((spinner) => spinner.classList.toggle('hidden', !isLoading));
  };

  window.addEventListener('scroll', toggleVisibility);
  window.addEventListener('resize', toggleVisibility);
  toggleVisibility();

  if (originalButton) {
    const observer = new MutationObserver(syncState);
    observer.observe(originalButton, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled', 'class'],
    });
    syncState();
  }

  stickyButton.addEventListener('click', () => {
    const originalIsDisabled =
      originalButton?.hasAttribute('disabled') || originalButton?.getAttribute('aria-disabled') === 'true';
    if (originalButton && !originalIsDisabled) {
      originalButton.click();
      requestAnimationFrame(syncState);
    }
  });
});
